import React from "react";
import { Label, Alert, Select, Hint } from "@americanexpress/dls-react";

/**
 * SelectField is a reusable dropdown component using @americanexpress/dls-react Select.
 *
 * Props:
 * - id: string - The unique identifier for the select element.
 * - label: string - The label displayed above the select.
 * - value: any - The currently selected value.
 * - options: array - The list of options to display in the dropdown.
 * - onChange: function - Callback when the selected value changes.
 * - error: string (optional) - Error message to display below the select.
 * - ...rest: any - Additional props passed to the Select component.
 */
const PEPSelectField = ({ id, label, header, value, options, onChange, error, hint, ...rest }) => (
  <>
    <div className="col-md-1 col-xs-12 pad-3-t pad-2-b">
      {label && <Label htmlFor={id}>{label}</Label>}
    </div>
    <div className="col-md-11 col-xs-12 pad-2-b">
      {header && <p>{header}</p>}
      <Select
        id={id}
        options={options}
        value={value}
        onChange={onChange}
        {...rest}
      />
      {hint && <Hint>{hint}</Hint>}
      {error && <Alert status="error">{error}</Alert>}
    </div>
  </>
);

export default PEPSelectField;
